import React, { Component } from 'react';
import Btn from '../../components/btn';
import smoothscroll from 'smoothscroll-polyfill';
export default class Test extends Component {
	constructor(props) {
		super(props);
		this.state = {
			step: 1,
			answersBoolHide: [],
			answersHide: [],
			answersBool: [],
			answers: []
		};
		this.json = require('./questions.json');
		this.myRefImg1 = React.createRef();
		this.myRefImg2 = React.createRef();
		this.myRefText = React.createRef();

	}
	componentDidMount(){
		// this.setState({
		// 	step: 10
		// });
		this.resetAnswers();
		document.addEventListener("keydown", this._handleKeyDown);
		smoothscroll.polyfill();
		// console.log('sdf');
	}
	componentWillUnmount() {
		document.removeEventListener("keydown", this._handleKeyDown);
	}
	_handleKeyDown = (event) => {
		switch( event.keyCode ) {
			
			case 37:
				// console.log('left');
				this.prevQuestion();
				break;
			case 40:
				// console.log('down');
				if(this.state.step === Object.keys(this.json).length) {
					this.getResult();
				} else {
					this.nextQuestion();
				}
				break;
			case 39:
				// console.log('right');
				if(this.state.step === Object.keys(this.json).length) {
					this.getResult();
				} else {
					this.nextQuestion();
				}
				break;
			case 38:
				// console.log('up');
				this.prevQuestion();
				break;
			default: 
				break;
		}
	}
	componentDidUpdate(){
	
		
		this.myRefImg1.current.onload = function(e){
			this.classList.add('show');
		}
		this.myRefImg2.current.onload = function(e){
			this.classList.add('show');
		}
	}
	resetAnswers(){
		// this.json = require('./questions.json');
		
		const array = [];
		for( let i = 0; i < Object.keys(this.json).length; i++){
			
			array.push(null);
			
		}
		this.setState(({answersBool, answers})=>{
			return {answersBool: array, answersBoolHide: array, answersHide:array, answers: array};
		});
	}
	setAnswer(index){
		
		this.setState(({answersBool, answers})=>{
			const newArrayBool = [...answersBool];
			const newArray = [...answers];
			newArrayBool[this.state.step - 1] = this.json[this.state.step].true === index;
			newArray[this.state.step - 1] = index;
			return {answersBool: newArrayBool, answers: newArray};
		}, this.scrollToAnswer);
		// setTimeout(this.scrollToAnswer, 200);
		if(this.state.answersBool[this.state.step - 1] == null){
			
			this.setState(({answersBool, answers})=>{
				const newArrayBool = [...answersBool];
				const newArray = [...answers];
				return {answersBoolHide: newArrayBool, answersHide: newArray};
			});
		} 
		
		
	}

	scrollToAnswer(){
		setTimeout(function(){

			document.querySelector('.test__anchor').scrollIntoView({behavior: 'smooth'});
			// document.querySelector('.test').scrollTop = 100;
		}, 200);
		// this.SmoothVerticalScrolling(document.querySelector('.test__answer'), 200)
		// document.querySelector('.test__answer').scrollTo(0,this.myRefText.current.scrollHeight);
		console.log('yes');
	}
	
	toRealAnswer(){
		this.setState(({answersBoolHide, answersHide})=>{
			const newArrayBool = [...answersBoolHide];
			const newArray = [...answersHide];
			return {answersBool: newArrayBool, answers: newArray};
		});
	}
	nextQuestion(){
		document.querySelector('.test__inner').scrollIntoView();
		if(this.state.answersBool[this.state.step - 1] !== null){
			this.setState(({step})=>{
				return {step: step+1}
			});
			this.myRefImg1.current.classList.remove('show');
			this.myRefImg2.current.classList.remove('show');
			this.toRealAnswer();
		}
		
	}
	prevQuestion(){
		document.querySelector('.test__inner').scrollIntoView();
		if(this.state.step !== 1){
			this.setState(({step})=>{
				return {step: step-1}
			});
			this.myRefImg1.current.classList.remove('show');
			this.myRefImg2.current.classList.remove('show');
			this.toRealAnswer();
		}
	}

	getResult(){
		
		this.props.updatePage(3);
		let result = 0;
		for( let i = 0; i < this.state.answersBool.length; i++){
			if(this.state.answersBool[i]){
				result++;
			}
		}
		this.props.updateScore(result);
	}

	
	render() {
		let testClass = '';
		let testBtnPrev = '';
		let testBtnNext = '';
		let testTitle = '';
		let testText = '';
		let classQuestions = '';
		if(this.state.answersBool[this.state.step - 1] !== null){
			testClass = `test--${this.state.answersBool[this.state.step - 1]}`;
			classQuestions = `test__questions--${this.state.answers[this.state.step - 1]}`;
			if(this.state.step === Object.keys(this.json).length) {
				testBtnNext = <Btn className='test__btn test__btn--result test__btn--right' color={'test'} arrow={'right'} onClick={this.getResult.bind(this)} onKeyPress={this.checkKeyDown}>Результаты</Btn>;
			} else {
				testBtnNext = <Btn className='test__btn test__btn--right' color={'test'} arrow={'right'} onClick={this.nextQuestion.bind(this)}>Следующий</Btn>;
			}
			testTitle = `${this.json[this.state.step][`${this.state.answersBool[this.state.step - 1]}_title`]}`;
			testText = <div className="test__answer-text">{this.json[this.state.step][`${this.state.answersBool[this.state.step - 1]}_text`]}</div>;
			
		}
		if(this.state.step !== 1){
			testBtnPrev = <Btn className='test__btn' color={'test'} arrow={'left'} onClick={this.prevQuestion.bind(this)}>Предыдущий</Btn>;
		}  else {
			testBtnPrev = '';
		}
		
		// console.log(this.state.answers);
		
		let imgSrc1 = '';
		let imgSrc2 = '';
		if(window.innerWidth < 768){
			imgSrc1 = `./img/questions_mobile${this.json[this.state.step].img1}`;
			imgSrc2 = `./img/questions_mobile${this.json[this.state.step].img2}`;
		} else {
			imgSrc1 = `./img/questions${this.json[this.state.step].img1}`;
			imgSrc2 = `./img/questions${this.json[this.state.step].img2}`;
		}
		// console.log(this.myRefImg1);
		
		return (
			<div className={`test ${testClass}`}  >
				<div className="container">
					<div className="test__inner">
						<div className="test__header">
							<div className="test__title">
							{this.json[this.state.step].title}
							</div>
							<div className="test__score"> {this.state.step} | {Object.keys(this.json).length}</div>
						</div>
						<div className="test__body">
							<div className={`test__questions ${classQuestions}`}>
								<div className={`test__question`} onClick={this.setAnswer.bind(this, '1')}>
									<img src={imgSrc1} ref={this.myRefImg1} alt="" />
								</div>
								<div className={`test__question`} onClick={this.setAnswer.bind(this, '2')}>
									<img src={imgSrc2} ref={this.myRefImg2} alt="" />
								</div>
							</div>
						</div>
						<div className="test__btns">
						{testBtnPrev}
						{testBtnNext}
						</div>
						<div className="test__answer"  ref={this.myRefText}>
							<div className="test__answer-title">
							{testTitle}
							</div>
							
							{testText}
							
						</div>
						<div className="test__anchor"></div>
					</div>
				</div>
			</div>
		);
	}
}
